import { Components, Theme } from "@mui/material";

export const MuiAlert: Components<Omit<Theme, "MuiAlert">>["MuiAlert"] = {
  styleOverrides: {
    root: {
      borderRadius: 8,
      padding: "12px 16px",
      display: "flex",
      alignItems: "center",
      gap: 12,

      fontFamily: "Inter",
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "16px",
      letterSpacing: "0%",

      "& .MuiAlert-icon": {
        marginRight: 0,
        fill: "currentColor",
      },

      "& .MuiAlert-action": {
        color: "inherit",
      },
    },
    standardError: ({ theme: { palette } }) => ({
      backgroundColor: palette.custom.red[50],
      color: palette.custom.red[800],
      border: "none",
      boxShadow: "none",
    }),
    standardWarning: ({ theme: { palette } }) => ({
      backgroundColor: palette.custom.orange[50],
      color: palette.custom.orange[800],
      border: "none",
      boxShadow: "none",
    }),
    standardInfo: ({ theme: { palette } }) => ({
      backgroundColor: palette.custom.blue[50],
      color: palette.custom.blue[800],
      border: "none",
      boxShadow: "none",
    }),
    standardSuccess: ({ theme: { palette } }) => ({
      backgroundColor: palette.custom.green[50],
      color: palette.custom.green[800],
      border: "none",
      boxShadow: "none",
    }),
    outlinedError: ({ theme: { palette } }) => ({
      backgroundColor: palette.custom.red[50],
      color: palette.custom.red[800],
      border: `2px solid ${palette.custom.red[200]}`,
      boxShadow: `
        0px 2px 5px 0px #9C9C9C1A,
        0px 9px 9px 0px #9C9C9C17,
        0px 20px 12px 0px #9C9C9C0D,
        0px 35px 14px 0px #9C9C9C03,
        0px 54px 15px 0px #9C9C9C00
      `,
    }),
    outlinedWarning: ({ theme: { palette } }) => ({
      backgroundColor: palette.custom.orange[50],
      color: palette.custom.orange[800],
      border: `2px solid ${palette.custom.orange[200]}`,
      boxShadow: `
        0px 2px 5px 0px #9C9C9C1A,
        0px 9px 9px 0px #9C9C9C17,
        0px 20px 12px 0px #9C9C9C0D,
        0px 35px 14px 0px #9C9C9C03,
        0px 54px 15px 0px #9C9C9C00
      `,
    }),
    outlinedInfo: ({ theme: { palette } }) => ({
      backgroundColor: palette.custom.blue[50],
      color: palette.custom.blue[800],
      border: `2px solid ${palette.custom.blue[200]}`,
      boxShadow: `
        0px 2px 5px 0px #9C9C9C1A,
        0px 9px 9px 0px #9C9C9C17,
        0px 20px 12px 0px #9C9C9C0D,
        0px 35px 14px 0px #9C9C9C03,
        0px 54px 15px 0px #9C9C9C00
      `,
    }),
    outlinedSuccess: ({ theme: { palette } }) => ({
      backgroundColor: palette.custom.green[50],
      color: palette.custom.green[800],
      border: `2px solid ${palette.custom.green[200]}`,
      boxShadow: `
        0px 2px 5px 0px #9C9C9C1A,
        0px 9px 9px 0px #9C9C9C17,
        0px 20px 12px 0px #9C9C9C0D,
        0px 35px 14px 0px #9C9C9C03,
        0px 54px 15px 0px #9C9C9C00
      `,
    }),
  },
};
